import { createBrowserRouter } from "react-router-dom";
import HomeLayout from "./components/home/HomeLayout";
import UserLayout from "./Layout/UserLayout";
import { privateRoutes } from "./views/PrivateRoutes";
// import { publicRoutes } from "./views/PublicRoutes";
import NotFound from "./components/NotFound/NotFound";
import CustomLogin from "./components/user/auth/customLogin/cLogin";
import DirectLogin from "./components/user/auth/customLogin/DirectLogin";
// import Language from "./components/Language/Language";
import FeedbackFormPage from "./components/user/lms/FeedbackFormComponent";
import Language from "./components/Language/Language";
import ModuleChapterListUiComponent from "./components/user/lms/ModuleChapterListUiComponent";

export const routes = createBrowserRouter([
  {
    path: "/user/language",
    element: <Language />,
  },
  {
    path: "/user/login",
    element: <HomeLayout />,
    // children: publicRoutes,
  },
  {
    path: "/user",
    element: <UserLayout />,
    children: privateRoutes,
  },
  {
    path: "/clgn",
    element: <CustomLogin />,
  },
  {
    path: "/dirlgn",
    element: <DirectLogin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
